import * as actions from './actions'
import * as sagas from './sagas'
import * as selectors from './selectors'
import actionTypes from './actionTypes'
import reducer from './reducer'

export default {
  actionTypes,
  actions,
  reducer,
  sagas,
  selectors,
}
